import { render } from "./ConfiguracionElectrica.vue?vue&type=template&id=0708f96a&scoped=true"
import script from "./ConfiguracionElectrica.vue?vue&type=script&lang=js"
export * from "./ConfiguracionElectrica.vue?vue&type=script&lang=js"

import "./ConfiguracionElectrica.vue?vue&type=style&index=0&id=0708f96a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0708f96a"]])

export default __exports__